import {
  QueryHookOptions,
  QueryResult,
  SuspenseQueryHookOptions,
  UseSuspenseQueryResult,
} from '@apollo/client';

type QueryVariables = {
  filter?: string | null;
  pageSize?: number | null;
  pageToken?: string | null;
  orderBy?: string | null;
};

// Overload for regular hooks
export function withRequiredVariables<
  TData extends Record<string, any>,
  TRequiredVars extends Record<string, any>,
>(
  useQuery: (...args: any[]) => QueryResult<TData, TRequiredVars>,
): (
  options?: QueryHookOptions<TData, QueryVariables & TRequiredVars>,
) => QueryResult<TData, QueryVariables & TRequiredVars>;

// Overload for suspense hooks
export function withRequiredVariables<
  TData extends Record<string, any>,
  TRequiredVars extends Record<string, any>,
>(
  useQuery: (
    ...args: any[]
  ) => UseSuspenseQueryResult<TData | undefined, TRequiredVars>,
): (
  options?: SuspenseQueryHookOptions<
    TData | undefined,
    QueryVariables & TRequiredVars
  >,
) => UseSuspenseQueryResult<TData | undefined, QueryVariables & TRequiredVars>;

// Implementation
export function withRequiredVariables(useQuery: (...args: any[]) => any) {
  return (options?: any) => {
    return useQuery({
      ...options,
      variables: options?.variables as any,
    });
  };
}
